import React from "react";
import Table from "../../../../component-lib/Organisms/table/EventEHRTable";
import EventEHRSwitchButton from "../../../../component-lib/Molecules/switch-button/EventEHRSwitchButton";
import Heading from "../../../../component-lib/Atoms/heading/EventEHRHeading";
const Patient = ({ rowData, setRolesRowData }: any) => {
  // Roles and responsibility column
  const rAndResColumns = [
    {
      field: "roles",
      label: <div>Permission</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.roles}</p>;
      },
    },
    {
      field: "description",
      label: <div>Description</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal w-[70vw]">
            {row?.description}
          </p>
        );
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any, index: any) => {
        return (
          <p className="text-neutral-90 font-normal">
            <EventEHRSwitchButton
              checked={row?.status}
              onChange={() => {
                setRolesRowData((prev: any) =>
                  prev.map((item: any, i: any) =>
                    i === index ? { ...item, status: !item.status } : item
                  )
                );
              }}
            />
          </p>
        );
      },
    },
  ];

  return (
    <div className="flex flex-col h-full gap-3 pt-4">
      <Heading title={"Patient"} customStyle={{ color: "#1D1D1D" }} />{" "}
      <Table columns={rAndResColumns} rows={rowData} overflowX="hidden" />
    </div>
  );
};

export default Patient;
